// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".homepage[data-v-67e2994b]{overflow-x:clip;background:#1c0c32;padding-bottom:155px}.homepage__rating[data-v-67e2994b]{position:relative}.homepage__rating-glow[data-v-67e2994b]{z-index:1;position:absolute;width:787px;height:482px;top:50px;left:25%;transform:translate(-50%, -50%);pointer-events:none}.homepage__rating-section[data-v-67e2994b]{position:relative;z-index:0}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
